type ToursState = { tours: { requested: string | null } };

/**
 * Spread into the root store like the add-ons slice. A tour is started by
 * request so that a menu item or a panel button only has to name it: the
 * component that owns the tours reads the request and clears it.
 */
export const toursState: ToursState = {
    tours: {
        requested: null,
    },
};

export const toursActions = {
    startTour({ commit }: { commit(mutation: string, payload?: unknown): void }, id: string) {
        commit('requestTour', id);
    },
};

export const toursMutations = {
    requestTour(state: ToursState, id: string) {
        state.tours.requested = id;
    },
    clearTourRequest(state: ToursState) {
        state.tours.requested = null;
    },
};
